<script lang="ts">
	import { Button, ButtonV2 } from '@Shelly/shelly-design-system/index';
	import { format } from 'svelte-i18n';

	import CancelCameraCloudStorageSubscription from 'src/components/Settings/CameraCloudStorage/CancelCameraCloudStorageSubscription.svelte';
	import type { PaypalInfoReturnValue } from 'src/types/Subscription';
	import { showNewLayout } from 'src/stores/toDelete';

	export let showCancelSubscriptionModal = false;
	// Forwarded from the billing-collapse host. Used to gate the Premium
	// cancel button so this component stays correct when it is rendered
	// only for an active Camera Cloud Storage subscription (no Premium).
	export let paypalInfo: PaypalInfoReturnValue | null = null;

	$: isPremiumCancellable =
		!!paypalInfo && ['ACTIVE', 'SUSPENDED'].includes(paypalInfo.subscriptionStatus);

	$: ButtonComp = $showNewLayout ? ButtonV2 : Button;
</script>

<div class="d-flex flex-column align-items-md-start gap-s">
	{#if isPremiumCancellable}
		<svelte:component
			this={ButtonComp}
			class="width-md-auto width-sm-full"
			variant="danger"
			size="m"
			on:click={() => (showCancelSubscriptionModal = true)}
		>
			{$format('plan_information_cancel_subscription', {
				default: 'Cancel Subscription',
			})}
		</svelte:component>
	{/if}

	<!-- Self-contained: renders nothing when there is no active Camera
	     Cloud Storage plan, so the host can mount this unconditionally. -->
	<CancelCameraCloudStorageSubscription />
</div>
